/* eslint-disable import/prefer-default-export */
const JAVA_LESSONS = "https://www.c3d.io/java/";

export {JAVA_LESSONS};